import { Divider, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { ReactElement } from "react";
import { PriceFeature } from "./PriceFeature";

type PriceCardProps = {
  price: string;
  title: string;
  description: string;
  features: string[];
  buyLink: ReactElement;
};

export const PriceCard = (props: PriceCardProps) => {
  const { price, description, features, title, buyLink } = props;

  return (
    <Stack
      padding="64px"
      width="sm"
      maxWidth="100%"
      justify="space-between"
      align="flex-start"
      spacing="32px"
      overflow="hidden"
      borderRadius="xl"
      boxShadow={useColorModeValue("xl", "xl-dark")}
      bg="fg.accent.default"
    >
      <Stack spacing="16px" alignSelf="stretch">
        <Stack spacing="16px" alignSelf="stretch">
          <Stack
            justify="center"
            align="center"
            spacing="15px"
            alignSelf="stretch"
          >
            <Text
              textStyle="5xl"
              fontWeight="bold"
              textAlign="center"
              color="accent"
            >
              {price}
            </Text>
            <Stack justify="center" align="center">
              <Text
                color="fg.accent.emphasized"
                fontWeight="bold"
                textStyle="xl"
              >
                {title}
              </Text>
              <Text color="fg.accent.emphasized" textStyle="md">
                {description}
              </Text>
            </Stack>
          </Stack>
          <Divider orientation="horizontal" />
        </Stack>
        <Text
          color="on-fg.accent.emphasized"
          fontWeight="semibold"
          textStyle="lg"
        >
          Includes
        </Text>
        <Stack>
          {features.map((feature) => (
            <PriceFeature feature={feature} />
          ))}
        </Stack>
      </Stack>
      {buyLink}
    </Stack>
  );
};
